import {useState,useEffect,useRef} from 'react'
import logo from '../../assets/newlogo.png'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
const BASE_URL = process.env.REACT_APP_BASE_URL;
const MarketPlaceFeedNavbar = ({searchTerm,setSearchTerm,searchResults,setSearchResults,setSearchParams}) => {
  // console.log("The results are:",searchResults)
    const navigate=useNavigate()
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
    const modalRef = useRef(null);
    useEffect(()=>{
          if (!searchTerm || searchTerm.trim() === "") return;
          const fetchSearchResults=async()=>{
            try {
               const response = await axios.get(
            `${BASE_URL}/marketplace/researcher/feed/search?q=${searchTerm}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                'x-api-key': process.env.REACT_APP_X_API_KEY,
              },
            }
          );
          //  console.log("The response is:",response.data)
           setSearchResults(response.data)
            } catch (error) {
              console.log("Error while search:",error)
            }
          }
          fetchSearchResults()
    
      },[searchTerm])
     useEffect(() => {
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsProfileDropdownOpen(false);
      }
    };
    if (isProfileDropdownOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isProfileDropdownOpen]);

    const logout = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };

  return (
    <nav className="hidden md:block w-full  flex items-center justify-center transition-all duration-300 sticky top-0 z-[999] px-6 py-4 bg-white border-b border-gray-100 shadow-sm ">
       <div className="w-full max-w-[1920px] mx-auto flex justify-between items-center gap-6">
         {/* Logo Section */}
      <div className="flex items-center gap-4 w-full max-w-[35%]">
        <div className="cursor-pointer">
          <img
            src={logo}
            className="w-full h-16  object-contain"
            alt="Logo"
            onClick={(e) => navigate("/home")}
          />
        </div>
      </div>
        {/* Search Bar */}
            {/* {!hideSearchBar && profile && ( */}
            {/* ref={searchRef} */}
              <div className="w-full max-w-[30%] relative" >
                <div className="relative">
                  <input
                    type="search"
                    className="w-full px-5 py-3 pr-12 bg-white outline-none text-sm rounded-xl border border-gray-300 text-gray-900 placeholder:text-gray-400 hover:border-gray-400 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                    placeholder="Search for research, journals, people, etc."
                    value={searchTerm}
                    onChange={(e)=>{
                      setSearchTerm(e.target.value)
                      setSearchParams({ search: e.target.value });
                    }}
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   setSearchTerm(value);
                    //   handleSearch(value);
      
                    //   if (location.pathname === "/home") {
                    //     const params = new URLSearchParams(location.search);
                    //     if (value.trim()) {
                    //       params.set("search", value.trim());
                    //     } else {
                    //       params.delete("search");
                    //     }
                    //     navigate(`/home?${params.toString()}`);
                    //   }
                    // }}
                    // onKeyDown={(e) => {
                    //   if (e.key === "Enter" && location.pathname !== "/home") {
                    //     navigate(
                    //       `/home?search=${encodeURIComponent(searchTerm)}`
                    //     );
                    //   }
                    // }}
                  />
                  <div 
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-6 flex items-center justify-center cursor-pointer"
                    // onClick={() => {
                    //   handleSearch(searchTerm);
                    //   if (location.pathname !== "/home") {
                    //     const params = new URLSearchParams(location.search);
                    //     if (searchTerm.trim()) {
                    //       params.set("search", searchTerm.trim());
                    //     } else {
                    //       params.delete("search");
                    //     }
                    //     navigate(`/home?${params.toString()}`);
                    //   }
                    // }}
                  >
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                </div>
      
                {/* {isSearching && (
                  <div className="mt-2 text-sm text-gray-500 flex items-center gap-2">
                    <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                    Searching...
                  </div>
                )} */}
      
                {searchTerm.trim() && searchResults.length > 0 && (
                  <div className="absolute top-full mt-2 left-0 right-0 bg-white rounded-xl shadow-lg border border-gray-200 max-h-80 overflow-y-auto z-20">
                    <div className="p-2">
                      {searchResults.map((user) => (
                        <div
                          key={user.id}
                          className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                          onClick={() => {
                            setSearchResults([]);
                            setSearchParams({ search:user?.name });
                            setSearchTerm("")
                            // setProfileId(user.id);
                            // setProfileData(user);
                            console.log("user: ", user.id);
      
                            // if (String(user.id) === String(profileId)) {
                            //   navigate("/profile-view", {
                            //     state: {
                            //       isOwnProfile: true,
                            //       profileData: user,
                            //     },
                            //   });
                            // } else {
                            //   navigate(`/user-profile/${user.id}`, {
                            //     state: {
                            //       isOwnProfile: false,
                            //       profileData: user,
                            //     },
                            //   });
                            // }
                          }}
                        >
                          <div className="relative">
                            <img
                              src={user?.profile_data?.profile_picture}
                              alt={user?.profile_data?.name}
                              className="w-10 h-10 rounded-lg object-cover border border-gray-200"
                            />
                            <div
        className={`absolute -bottom-1 -right-1 w-2.5 h-2.5 rounded-full border border-white ${
          user?.profile_data?.is_online ? 'bg-green-500' : 'bg-gray-400'
        }`}
      />
      
                          </div>
                          <div>
                            <p className="font-medium text-gray-900 text-sm">{user.name}</p>
                            <p className="text-xs text-gray-500">By: {user?.university_name ? user?.university_name : 'Researcher'}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )} 
              </div>
            {/* )}


              {/* Right Side Actions */}
              {/* ref={profileRef} */}
      <div className="flex justify-end items-center gap-4 max-w-[35%] !important" >
        {/* {!hideBell && profile && ( */}
          <>
          {/* ref={bellRef} */}
            <div style={{ position: "relative" }} >
              <button
                // onClick={async () => {
                //   setOpen(!open);
                //   if (!open) {
                //     await markAllNotificationsRead(notifications);
                //     setUnreadCount(0);
                //   }
                // }}
                className="relative w-10 h-10 bg-[#e8f0f7] flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
              >
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
                {/* {unreadCount > 0 && ( */}
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full">
                    {/* {unreadCount} */} 0
                  </span>
                {/* )} */}
              </button>

              {/* {open && <Notifications onReadAll={handleReadAll} />} */}
            </div>

            <div>
              <button
                onClick={() => navigate("/chat")}
                className="relative w-10 h-10 bg-[#e8f0f7] flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
              >
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                {/* {totalUnreadMessages > 0 && ( */}
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full">
                    {/* {totalUnreadMessages} */} 0
                  </span>
                {/* )} */}
              </button>
            </div>
          </>
        {/* )} */}
        {/* {!hideHome && (
          <div className="pr-4">
            {location.pathname !== "/home" && (
              <Link to="/home" className="hover:bg-transparent hover:shadow-none">
                <button className="relative w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors">
                  <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                </button>
              </Link>
            )}
          </div>
        )} */}

        <ul className="flex gap-4 list-none items-center w-max">
          {/* {!hideFilter && ( */}
            <div className="flex gap-4 items-center">
              <select
                // value={
                //   new URLSearchParams(location.search).get("type") || "all"
                // }
                // onChange={(e) => handleContentFilter(e.target.value)}
                className="px-4 py-2.5 text-sm font-medium border border-gray-100 rounded-xl bg-white text-gray-900 cursor-pointer outline-none appearance-none pr-10 hover:border-gray-400 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                style={{
                  backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 12px center'
                }}
              >
                <option value="all">All</option>
                <option value="publication">Publications</option>
                <option value="video">Videos</option>
                <option value="image">Images</option>
                <option value="code">Code</option>
                {/* <option value="post">Posts</option> */}
              </select>
            </div>
          {/* )} */}

          {/* {!hideLogo && profile && ( */}
          {/* onClick={toggleProfileDropdown} */}
            <li className="cursor-pointer" onClick={()=>setIsProfileDropdownOpen(!isProfileDropdownOpen)}>
              <div className="w-12 h-12 flex justify-center items-center rounded-full p-1 overflow-hidden border-2 border-gray-50 hover:border-[#0f6abf] transition-colors">
                <img
                  src={''}
                  // src='https://mindaibucket.s3.us-east-2.amazonaws.com/profile_pictures/HeroImage.png'
                  alt="User"
                  className="w-full h-full object-cover"
                />
              </div>
            </li>
          {/* )} */}

          {/* <AddNewDropdown
            isOpen={openDropdown === "btn1"}
            onClose={() => setOpenDropdown(null)}
          /> */}
        </ul>
         {/* && profile */}
        {isProfileDropdownOpen && (
          <div ref={modalRef} className="absolute top-16 right-6 bg-white rounded-xl shadow-lg border border-gray-200 w-64 py-2 backdrop-blur-lg z-[1000]">
            <div className="p-2">
              <Link
                to='/marketplace/independent_researcher/dashboard'
                className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
              >
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span className="text-sm font-medium">Your Dashboard</span>
              </Link>
              
              {/* <Link 
                to="/changepassword" 
                className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
              >
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
                <span className="text-sm font-medium">Change Password</span>
              </Link> */}
              
              {/* {isTeacher ? ( */}
                {/* <Link 
                  to="/teacher" 
                  className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
                >
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                  <span className="text-sm font-medium">Teacher Profile</span>
                </Link> */}
            {/* //   ) : (
            //     <Link
            //       to="/teacher-profile"
            //       state={{
            //         isOwnProfile: true,
            //         profileData: profile,
            //       }}
            //       className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
            //     >
            //       <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            //         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            //       </svg>
            //       <span className="text-sm font-medium">Become a Teacher</span>
            //     </Link>
            //   )} */}
{/*               
              <Link 
                to="/courses" 
                className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
              >
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                <span className="text-sm font-medium">Browse Courses</span>
              </Link> */}
              <Link 
  to="/home" 
  className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
>
  <svg 
    className="w-4 h-4 text-gray-500" 
    fill="none" 
    stroke="currentColor" 
    viewBox="0 0 24 24"
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth="2" 
      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.5 7h13L17 13M7 13H5.4M17 13l1.5 7M6 21a1 1 0 100-2 1 1 0 000 2zm12 0a1 1 0 100-2 1 1 0 000 2z" 
    />
  </svg>
  <span className="text-sm font-medium">Home</span>
</Link>

              {/* {(playlistCourses.length > 0 || paidCourses.length > 0) && (
                <Link 
                  to="/student" 
                  className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
                >
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  <span className="text-sm font-medium">Enrolled Courses</span>
                </Link>
              )} */}
              
              {/* <div
                className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-red-50 transition-colors text-red-500 cursor-pointer"
                // onClick={() => setShowDeleteModal(true)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span className="text-sm font-medium">Delete Account</span>
              </div> */}
              
              <div className="border-t border-gray-200 mt-2 pt-2">
                <div
                  className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer"
                  onClick={logout}
                >
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  <span className="text-sm font-medium">Log out</span>
                </div>
              </div>
            </div>
          </div>
         )}
      </div>
      
       </div>
    </nav>
  )
}

export default MarketPlaceFeedNavbar